module.exports = __webpack_public_path__ + "static/media/bg1.91df6110.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg1.png
// module id = 90
// module chunks = 0